import { gpCommon } from '../app';
import * as angular from 'angular';
import { IAuthorisationCheckerService, IAuthorisationCheckerService_serviceName, IAuthorisationStatus } from './authorisation-checker-with-caching-service';

export interface ISimpleHttpService {
    /**
    * Shortcut method to perform GET request.
    *
    * @param url Relative or absolute URL specifying the destination of the request
    * @param config Optional configuration object
    */
    get<T>(url: string, config?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>>;
    getValue<T>(url: string, config?: ng.IRequestShortcutConfig): ng.IPromise<T>;

    /**
    * Shortcut method to perform GET request.
    *
    * @param url Relative or absolute URL specifying the destination of the request
    * @param config Optional configuration object
    */
    delete<T>(url: string, config?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>>;

    /**
    * Shortcut method to perform POST request.
    *
    * @param url Relative or absolute URL specifying the destination of the request
    * @param data Request content
    * @param config Optional configuration object
    */
    post<T>(url: string, data: any, config?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>>;

    /**
    * Shortcut method to perform PUT request.
    *
    * @param url Relative or absolute URL specifying the destination of the request
    * @param data Request content
    * @param config Optional configuration object
    */
    put<T>(url: string, data: any, config?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>>;

}

declare module 'angular' {
  namespace auto {
    interface IInjectorService {
      get(name: '$httpAuth'): ISimpleHttpService;
    }
  }
}

gpCommon.factory('$httpAuth', ['$http', '$q', IAuthorisationCheckerService_serviceName, function ($http: ng.IHttpService, $q: ng.IQService, authService: IAuthorisationCheckerService) {
    return new GamePlanAuthorizedHttpService($http, $q, authService);
}]);

function rejectIfEmpty<T>(req: ng.IPromise<ng.IHttpPromiseCallbackArg<T>>, $q: ng.IQService): ng.IPromise<T> {
    var deferred = $q.defer<T>();

    req.then(result => {
        if (result.data) {
            deferred.resolve(result.data);
        } else {
            deferred.reject("No data");
        }
    }).catch(reason => deferred.reject(reason));


    return deferred.promise;
}

class GamePlanAuthorizedHttpService implements ISimpleHttpService {
    constructor(private $http: ng.IHttpService, private $q: ng.IQService, private authService: IAuthorisationCheckerService) {

    }

    get<T>(url: string, originalConfig?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>> {
        return this.wrap(originalConfig || null, config => this.$http.get<T>(url, config));
    }

    getValue<T>(url: string, originalConfig?: ng.IRequestShortcutConfig): ng.IPromise<T> {
        return rejectIfEmpty(this.wrap(originalConfig || null, config => this.$http.get<T>(url, config)), this.$q);
    }

    delete<T>(url: string, originalConfig?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>> {
        return this.wrap(originalConfig || null, config => this.$http.delete<T>(url, config));
    }

    post<T>(url: string, data: any, originalConfig?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>> {
        return this.wrap(originalConfig || null, config => this.$http.post<T>(url, data, config));
    }

    put<T>(url: string, data: any, originalConfig?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpPromiseCallbackArg<T>> {
        return this.wrap(originalConfig || null, config => this.$http.put<T>(url, data, config));
    }

    private wrap<T>(config: ng.IRequestShortcutConfig | null, doHttp: (config: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>): ng.IPromise<ng.IHttpPromiseCallbackArg<T>> {

        const configCopy = GamePlanAuthorizedHttpService.copyConfig(config)
        var deferred = this.$q.defer<ng.IHttpPromiseCallbackArg<T>>();

        var check = this.authService.checkAuthorisationIfNeeded();

        check
            .then(authData => {
                GamePlanAuthorizedHttpService.setupConfig(configCopy, authData);

                var httpReq = doHttp(configCopy);
                httpReq
                    .then(response => deferred.resolve(response))
                    .catch(reason => deferred.reject(reason));
            })
            .catch(reason => {
                deferred.reject(reason);
            });

        return deferred.promise;
    }

    static copyConfig(config: ng.IRequestShortcutConfig | null) {
        if (config) {
            return angular.copy(config);
        } else {
            return {};
        }
    }

    static setupConfig(config: ng.IRequestShortcutConfig, authData: IAuthorisationStatus) {
        if (!config.headers) {
            config.headers = {};
        }
        config.headers['Authorization'] = 'bearer ' + authData.token;
    }
} 
